import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { FloatInput, showToast } from "src/componentes";
import { getLocal, NFeDto, STORAGENFE_KEY, updateLocal } from "../../NFe.Dto";
import { useNavigate } from "react-router-dom";
import {
  NFeExcluir,
  NFeFiltrar,
  NFeIncluir,
} from "src/services/Fiscal.Service";
import {
  MapearErrosServidor,
  MapearErrosServidorCampo,
} from "src/hook/Functions";
import moment from "moment";
import { showMessageBox } from "src/componentes/MessageBox/Messagebox";
import {
  FormType,
  InformacoesAdicionaisSchema,
} from "./NFe.Cadastro.InformacoesAdicionais.Dto";

const NFeCadastroInformacoesAdicionaisView = () => {
  const navigate = useNavigate();

  const nf = getLocal<NFeDto>(STORAGENFE_KEY);
  const informacoesAdicionais = nf?.informacoesAdicionais;

  const handleVoltar = () => () => {
    navigate("../volumes");
  };

  const form = useForm<FormType>({
    resolver: yupResolver(InformacoesAdicionaisSchema),
    defaultValues: {
      informacoesAdicionaisFisco:
        informacoesAdicionais?.informacoesAdicionaisFisco,
      informacoesComplementaresContribuinte:
        informacoesAdicionais?.informacoesComplementaresContribuinte,
      emissaoDataHora: nf?.emissaoDataHora
        ? moment(nf.emissaoDataHora).format("DD/MM/YYYY HH:mm:ss")
        : moment().format("DD/MM/YYYY HH:mm:ss"),
      saidaEntradaDataHora: nf?.saidaEntradaDataHora
        ? moment(nf.saidaEntradaDataHora).format("DD/MM/YYYY HH:mm:ss")
        : null,
    },
  });

  const Yes = async (data: FormType) => {
    updateLocal<NFeDto>(STORAGENFE_KEY, {
      informacoesAdicionais: {
        informacoesAdicionaisFisco: data.informacoesAdicionaisFisco ?? "",
        informacoesComplementaresContribuinte:
          data.informacoesComplementaresContribuinte ?? "",
      },
      emissaoDataHora: moment(
        data.emissaoDataHora,
        "DD/MM/YYYY HH:mm:ss",
      ).format("YYYY-MM-DDTHH:mm:ss"),
      saidaEntradaDataHora: data.saidaEntradaDataHora
        ? moment(data.saidaEntradaDataHora, "DD/MM/YYYY HH:mm:ss").format(
            "YYYY-MM-DDTHH:mm:ss",
          )
        : null,
    });

    const nf = getLocal<NFeDto>(STORAGENFE_KEY);
    showToast({
      message: "Inserindo...",
      title: "Em cadastro",
      variant: "Info",
    });

    if (nf?.id) {
      const nfeExiste = await NFeFiltrar({
        id: nf.id,
      });
      if (nfeExiste.data.success && nfeExiste.data.data.length > 0) {
        const response = await NFeExcluir(nf.id);
        if (!response.data.success) {
          MapearErrosServidor(response.data.notifications, showToast);
          return;
        }
      }
    }

    const response = await NFeIncluir(nf!);

    if (response.data.success) {
      navigate("/fiscal/nfe");
    } else {
      const notifications = response.data.notifications;
      notifications.forEach((item) => {
        item.key = item.key.replace("InformacoesAdicionais.", "");
      });

      MapearErrosServidorCampo(notifications, form.setError);
      response.data.notifications.forEach((item) => {
        showToast({
          message: item.key + ": " + item.message,
          title: "Erro",
          variant: "Danger",
        });
      });
    }
  };

  const onSubmit = async (data: FormType, e: any) => {
    showMessageBox("Deseja confirmar a NFe?", "Atenção!", "YesNo", "Question", {
      onYes: async () => {
        await Yes(data);
      },
    });
  };

  return (
    <>
      <Form noValidate onSubmit={form.handleSubmit(onSubmit)}>
        <Row>
          <Col xs={12}>
            <FloatInput
              label="Data Emissão"
              inputMask="datahora"
              registerField={form.register("emissaoDataHora")}
              errorsMessage={form.formState.errors.emissaoDataHora}
            />
          </Col>
          <Col xs={12}>
            <FloatInput
              label="Entrada/Saída"
              inputMask="datahora"
              registerField={form.register("saidaEntradaDataHora")}
            />
          </Col>
          <Col xs={12}>
            <FloatInput
              label="Informações Adicionais"
              inputMask="textarea"
              maxLength={2000}
              registerField={form.register(
                "informacoesComplementaresContribuinte",
              )}
              errorsMessage={
                form.formState.errors.informacoesComplementaresContribuinte
              }
            />
          </Col>
          <Col xs={12} className="mt-3">
            <FloatInput
              label="Informações do Fisco"
              inputMask="textarea"
              maxLength={2000}
              registerField={form.register("informacoesAdicionaisFisco")}
              errorsMessage={form.formState.errors.informacoesAdicionaisFisco}
            />
          </Col>
        </Row>
        <div className="fixed-bottom">
          <Container className="py-3">
            <Row>
              <Col xs={6} className="d-grid">
                <Button variant="outline-secondary" onClick={handleVoltar()}>
                  Voltar
                </Button>
              </Col>
              <Col xs={6} className="d-grid">
                <Button variant="outline-primary" type="submit">
                  Próximo
                </Button>
              </Col>
            </Row>
          </Container>
        </div>
      </Form>
    </>
  );
};

export default NFeCadastroInformacoesAdicionaisView;
